import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";
import "./pay.css";

const Payment = ({ mora, user, setUser, setFormConfig }) => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      tipo: user.tipo,
      contrato: user.contrato,
      codigo: user.codigo,
      valor: user.tipo === "Reservas" ? 0 : mora?.pago_total || user.saldo,
    },
  });

  const formatterMoney = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const handleValueChange = (event, onChange) => {
    // Dejamos únicamente números
    const numericValue = event.target.value.replace(/\D/g, "");

    // Si el usuario borró todo, dejamos el valor vacío
    if (numericValue === "") {
      onChange("");
      return;
    }

    // Guardamos el valor como número, NO como valor formateado
    onChange(Number(numericValue));
  };

  const OnSubmit = handleSubmit(async (data) => {
    setUser({ ...user, monto: data.valor });
    setFormConfig({ step: 4 });
  });

  useEffect(() => {
    setValue(
      "valor",
      user.tipo === "Reservas" ? 0 : mora?.pago_total || user.saldo,
    );
  }, [mora, user.saldo, user.tipo, setValue]);

  return (
    <main>
      <form onSubmit={OnSubmit}>
        <article
          className="text-back"
          onClick={() => setFormConfig({ step: 2 })}
        >
          <ArrowIcon />
          Volver
        </article>

        <label htmlFor="concepto">Concepto</label>
        <input
          className="inputPay"
          type="text"
          id="concepto"
          readOnly
          {...register("tipo")}
        />

        <label htmlFor="contrato">Contrato</label>
        <input
          className="inputPay"
          type="text"
          id="contrato"
          readOnly
          {...register("contrato")}
        />

        {user.tipo !== "Reservas" && (
          <>
            {user.mora === "1" && (
              <p className="text-danger">
                {`Tu plan vacacional presenta mora desde: ${mora?.fecha_mora}`}
              </p>
            )}

            <div className="radio-inputs mt-4 mb-3">
              {Number(mora?.pago_al_dia) > 0 && (
                <label>
                  <input
                    className="radio-input"
                    type="radio"
                    name="engine"
                    value={mora.pago_al_dia}
                    onChange={() =>
                      setValue("valor", Number(mora.pago_al_dia), {
                        shouldValidate: true,
                        shouldDirty: true,
                      })
                    }
                  />

                  <span className="radio-tile">
                    <span className="radio-label">
                      Pago para estar al día:{" "}
                      {formatterMoney.format(Number(mora.pago_al_dia))}
                    </span>
                  </span>
                </label>
              )}

              {Number(mora?.valor_cuota_mes) > 0 && (
                <label>
                  <input
                    className="radio-input"
                    type="radio"
                    name="engine"
                    value={mora.valor_cuota_mes}
                    onChange={() =>
                      setValue("valor", Number(mora.valor_cuota_mes), {
                        shouldValidate: true,
                        shouldDirty: true,
                      })
                    }
                  />

                  <span className="radio-tile">
                    <span className="radio-label">
                      Cuota sugerida:{" "}
                      {formatterMoney.format(Number(mora.valor_cuota_mes))}
                    </span>
                  </span>
                </label>
              )}

              {Number(mora?.pago_total || user.saldo) > 0 && (
                <label>
                  <input
                    className="radio-input"
                    type="radio"
                    name="engine"
                    value={mora?.pago_total || user.saldo}
                    onChange={() =>
                      setValue(
                        "valor",
                        Number(mora?.pago_total || user.saldo),
                        {
                          shouldValidate: true,
                          shouldDirty: true,
                        },
                      )
                    }
                  />

                  <span className="radio-tile">
                    <span className="radio-label">
                      Pagar saldo:{" "}
                      {formatterMoney.format(
                        Number(mora?.pago_total || user.saldo),
                      )}
                    </span>
                  </span>
                </label>
              )}
            </div>
          </>
        )}

        <div className={errors?.valor ? "ErrorContainer" : ""}>
          <label htmlFor="valor">Valor</label>

          <Controller
            name="valor"
            control={control}
            rules={{
              required: "Debe digitar un valor a pagar",
              validate: (value) =>
                Number(value) >= 1000 || "El valor mínimo debe ser de $1.000",
            }}
            render={({ field: { value, onChange, onBlur, ref } }) => (
              <input
                ref={ref}
                className="inputPay"
                type="text"
                id="valor"
                inputMode="numeric"
                autoComplete="off"
                placeholder="$ 0"
                value={
                  value !== "" && value !== null && value !== undefined
                    ? formatterMoney.format(Number(value))
                    : ""
                }
                onChange={(event) => handleValueChange(event, onChange)}
                onBlur={onBlur}
              />
            )}
          />

          {errors?.valor && (
            <span className="errorForm">
              <i className="fa-solid fa-circle-exclamation"></i>
              {errors.valor.message}
            </span>
          )}
        </div>

        <button disabled={isSubmitting} className="MercadoPago mt-3">
          {isSubmitting ? (
            <span className="spinner-border spinner-border-sm"></span>
          ) : (
            "Continuar"
          )}
        </button>
      </form>
    </main>
  );
};

export default Payment;
